export default "__VITE_ASSET__CGplzSdO__"